export const API_URL = process.env.REACT_APP_API_URL || window.location.origin;

// Authentication endpoints
export const AUTH_ENDPOINTS = {
  REGISTER: "/api/register",
  LOGIN: "/api/login"
};

// AI Chat endpoints
export const AI_ENDPOINTS = {
  MESSAGE: "/api/ai_message"
};

// Profile and matching endpoints
export const PROFILE_ENDPOINTS = {
  STATUS: "/profile_status",
  START_MATCH: "/start_match",
  MY_MATCHES: "/my_matches",
  ACTIVE_PROFILES_COUNT: "/active_profiles_count",
  MATCHING_STATUS: "/matching_status"
};

// Messages endpoints
export const MESSAGE_ENDPOINTS = {
  SEND: "/messages",
  GET_BY_USER: (userId) => `/messages/${userId}`,
  DIALOGS: "/dialogs"
};

// QR codes and invitations endpoints
export const QR_ENDPOINTS = {
  MY_QR: "/api/my_qr",
  REGENERATE_QR: "/api/my_qr/regenerate",
  CHECK_INVITE: (code) => `/api/invitations/check/${code}`,
  MY_INVITED_USERS: "/api/my_invited_users",
  BAN_USER: (userId) => `/api/ban_user/${userId}`
};

// Test endpoints (for development)
export const TEST_ENDPOINTS = {
  PROTECTED: "/protected",
  ME: "/me",
  ALL_USERS: "/all_users",
  WEBSOCKET_STATUS: "/websocket_status"
};

// WebSocket endpoint
export const WS_ENDPOINT = (token) => `/ws/${token}`;

// Legacy endpoints (for backward compatibility)
export const INVITE_ENDPOINTS = {
  GENERATE: "/api/invitations/generate",
  MY_INVITES: "/api/invitations/my",
  STATS: "/api/invitations/stats",
  VALIDATE: "/api/invitations/validate",
  REGISTER: "/api/register",
  QR_CODE: (id) => `/api/invitations/${id}/qr`,
  CHECK: (code) => `/invitation/check/${code}`,
  MY_QR: "/api/my_qr",
  REGENERATE_QR: "/api/my_qr/regenerate"
};
